module Colors

type Color=
    {
        R : float
        G : float
        B : float
        A : float
    }

let colors = 
    [
        {R = 128.0;G = 0.0;B = 0.0;A = 1.0}
        {R = 139.0;G = 0.0;B = 0.0;A = 1.0}
        {R = 165.0;G = 42.0;B = 42.0;A = 1.0}
        {R = 178.0;G = 34.0;B = 34.0;A = 1.0}
        {R = 220.0;G = 20.0;B = 60.0;A = 1.0}
        {R = 255.0;G = 0.0;B = 0.0;A = 1.0}
        {R = 255.0;G = 99.0;B = 71.0;A = 1.0}
        {R = 255.0;G = 127.0;B = 80.0;A = 1.0}
        {R = 205.0;G = 92.0;B = 92.0;A = 1.0}
        {R = 240.0;G = 128.0;B = 128.0;A = 1.0}
        {R = 233.0;G = 150.0;B = 122.0;A = 1.0}
        {R = 250.0;G = 128.0;B = 114.0;A = 1.0}
        {R = 255.0;G = 160.0;B = 122.0;A = 1.0}
        {R = 255.0;G = 69.0;B = 0.0;A = 1.0}
        {R = 255.0;G = 140.0;B = 0.0;A = 1.0}
        {R = 255.0;G = 165.0;B = 0.0;A = 1.0}
        {R = 255.0;G = 215.0;B = 0.0;A = 1.0}
        {R = 184.0;G = 134.0;B = 11.0;A = 1.0}
        {R = 218.0;G = 165.0;B = 32.0;A = 1.0}
        {R = 238.0;G = 232.0;B = 170.0;A = 1.0}
        {R = 189.0;G = 183.0;B = 107.0;A = 1.0}
        {R = 240.0;G = 230.0;B = 140.0;A = 1.0}
        {R = 128.0;G = 128.0;B = 0.0;A = 1.0}
        {R = 255.0;G = 255.0;B = 0.0;A = 1.0}
        {R = 154.0;G = 205.0;B = 50.0;A = 1.0}
        {R = 85.0;G = 107.0;B = 47.0;A = 1.0}
        {R = 107.0;G = 142.0;B = 35.0;A = 1.0}
        {R = 124.0;G = 252.0;B = 0.0;A = 1.0}
        {R = 127.0;G = 255.0;B = 0.0;A = 1.0}
        {R = 173.0;G = 255.0;B = 47.0;A = 1.0}
        {R = 0.0;G = 100.0;B = 0.0;A = 1.0}
        {R = 0.0;G = 128.0;B = 0.0;A = 1.0}
        {R = 34.0;G = 139.0;B = 34.0;A = 1.0}
        {R = 0.0;G = 255.0;B = 0.0;A = 1.0}
        {R = 50.0;G = 205.0;B = 50.0;A = 1.0}
        {R = 144.0;G = 238.0;B = 144.0;A = 1.0}
        {R = 152.0;G = 251.0;B = 152.0;A = 1.0}
        {R = 143.0;G = 188.0;B = 143.0;A = 1.0}
        {R = 0.0;G = 250.0;B = 154.0;A = 1.0}
        {R = 0.0;G = 255.0;B = 127.0;A = 1.0}
        {R = 46.0;G = 139.0;B = 87.0;A = 1.0}
        {R = 102.0;G = 205.0;B = 170.0;A = 1.0}
        {R = 60.0;G = 179.0;B = 113.0;A = 1.0}
        {R = 32.0;G = 178.0;B = 170.0;A = 1.0}
        {R = 47.0;G = 79.0;B = 79.0;A = 1.0}
        {R = 0.0;G = 128.0;B = 128.0;A = 1.0}
        {R = 0.0;G = 139.0;B = 139.0;A = 1.0}
        {R = 0.0;G = 255.0;B = 255.0;A = 1.0}
        {R = 0.0;G = 255.0;B = 255.0;A = 1.0}
        {R = 0.0;G = 206.0;B = 209.0;A = 1.0}
        {R = 64.0;G = 224.0;B = 208.0;A = 1.0}
        {R = 72.0;G = 209.0;B = 204.0;A = 1.0}
        {R = 175.0;G = 238.0;B = 238.0;A = 1.0}
        {R = 127.0;G = 255.0;B = 212.0;A = 1.0}
        {R = 176.0;G = 224.0;B = 230.0;A = 1.0}
        {R = 95.0;G = 158.0;B = 160.0;A = 1.0}
        {R = 70.0;G = 130.0;B = 180.0;A = 1.0}
        {R = 100.0;G = 149.0;B = 237.0;A = 1.0}
        {R = 0.0;G = 191.0;B = 255.0;A = 1.0}
        {R = 30.0;G = 144.0;B = 255.0;A = 1.0}
        {R = 173.0;G = 216.0;B = 230.0;A = 1.0}
        {R = 135.0;G = 206.0;B = 235.0;A = 1.0}
        {R = 135.0;G = 206.0;B = 250.0;A = 1.0}
        {R = 25.0;G = 25.0;B = 112.0;A = 1.0}
        {R = 0.0;G = 0.0;B = 128.0;A = 1.0}
        {R = 0.0;G = 0.0;B = 139.0;A = 1.0}
        {R = 0.0;G = 0.0;B = 205.0;A = 1.0}
        {R = 0.0;G = 0.0;B = 255.0;A = 1.0}
        {R = 65.0;G = 105.0;B = 225.0;A = 1.0}
        {R = 138.0;G = 43.0;B = 226.0;A = 1.0}
        {R = 75.0;G = 0.0;B = 130.0;A = 1.0}
        {R = 72.0;G = 61.0;B = 139.0;A = 1.0}
        {R = 106.0;G = 90.0;B = 205.0;A = 1.0}
        {R = 123.0;G = 104.0;B = 238.0;A = 1.0}
        {R = 147.0;G = 112.0;B = 219.0;A = 1.0}
        {R = 139.0;G = 0.0;B = 139.0;A = 1.0}
        {R = 148.0;G = 0.0;B = 211.0;A = 1.0}
        {R = 153.0;G = 50.0;B = 204.0;A = 1.0}
        {R = 186.0;G = 85.0;B = 211.0;A = 1.0}
        {R = 128.0;G = 0.0;B = 128.0;A = 1.0}
        {R = 216.0;G = 191.0;B = 216.0;A = 1.0}
        {R = 221.0;G = 160.0;B = 221.0;A = 1.0}
        {R = 238.0;G = 130.0;B = 238.0;A = 1.0}
        {R = 255.0;G = 0.0;B = 255.0;A = 1.0}
        {R = 218.0;G = 112.0;B = 214.0;A = 1.0}
        {R = 199.0;G = 21.0;B = 133.0;A = 1.0}
        {R = 219.0;G = 112.0;B = 147.0;A = 1.0}
        {R = 255.0;G = 20.0;B = 147.0;A = 1.0}
        {R = 255.0;G = 105.0;B = 180.0;A = 1.0}
        {R = 255.0;G = 182.0;B = 193.0;A = 1.0}
        {R = 245.0;G = 222.0;B = 179.0;A = 1.0}
        {R = 139.0;G = 69.0;B = 19.0;A = 1.0}
        {R = 160.0;G = 82.0;B = 45.0;A = 1.0}
        {R = 210.0;G = 105.0;B = 30.0;A = 1.0}
        {R = 205.0;G = 133.0;B = 63.0;A = 1.0}
        {R = 244.0;G = 164.0;B = 96.0;A = 1.0}
        {R = 222.0;G = 184.0;B = 135.0;A = 1.0}
        {R = 210.0;G = 180.0;B = 140.0;A = 1.0}
        {R = 188.0;G = 143.0;B = 143.0;A = 1.0}
        {R = 255.0;G = 228.0;B = 181.0;A = 1.0}
        {R = 255.0;G = 222.0;B = 173.0;A = 1.0}
        {R = 255.0;G = 218.0;B = 185.0;A = 1.0}
        {R = 112.0;G = 128.0;B = 144.0;A = 1.0}
        {R = 119.0;G = 136.0;B = 153.0;A = 1.0}
        {R = 0.0;G = 0.0;B = 0.0;A = 1.0}
        {R = 105.0;G = 105.0;B = 105.0;A = 1.0}
        {R = 128.0;G = 128.0;B = 128.0;A = 1.0}
        {R = 169.0;G = 169.0;B = 169.0;A = 1.0}
        {R = 192.0;G = 192.0;B = 192.0;A = 1.0}
    ]


// WEBPACK FOOTER //
// src/Colors.fs